// extracted by mini-css-extract-plugin
module.exports = {"point":"Point_point__2vDOc","selectable":"Point_selectable__1Tm9j","selected":"Point_selected__1Cea4"};